import React from "react";
import { SchedulesTemplate } from "../../Templates/SchedulesTemplate";

export const Schedules = () => {
  return <SchedulesTemplate />;
};
